import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 5385 10079"
    {...props}
  >
    <path
      d="M2559 5803H105L4150 277 3031 4082h2253L1410 9773z"
      style={{
        fill: "#2b2a29",
        stroke: "#fefefe",
        strokeWidth: 106.408,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
